import { render, staticRenderFns } from "./SaveFunds.vue?vue&type=template&id=3008faf6&scoped=true&"
import script from "./SaveFunds.vue?vue&type=script&lang=js&"
export * from "./SaveFunds.vue?vue&type=script&lang=js&"
import style0 from "./SaveFunds.vue?vue&type=style&index=0&id=3008faf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3008faf6",
  null
  
)

export default component.exports